import { ReactComponent as CeleryIcon } from './celery_icon.svg';
import { ReactComponent as CrustaceanIcon } from './crustacean_icon.svg';
import { ReactComponent as EggIcon } from './egg_icon.svg';
import { ReactComponent as FishIcon } from './fish_icon.svg';
import { ReactComponent as GlutenIcon } from './gluten_icon.svg';
import { ReactComponent as LupinsIcon } from './lupins_icon.svg';
import { ReactComponent as MilkIcon } from './milk_icon.svg';
import { ReactComponent as MustardIcon } from './mustard_icon.svg';
import { ReactComponent as NutsIcon } from './nuts_icon.svg';
import { ReactComponent as PeanutsIcon } from './peanuts_icon.svg';
import { ReactComponent as SesameIcon } from './sesame_icon.svg';
import { ReactComponent as ShellfishIcon } from './shellfish_icon.svg';
import { ReactComponent as SoyIcon } from './soy_icon.svg';
import { ReactComponent as SulfitesIcon } from './sulfites_icon.svg';


export const findAllergenComponent = (name) => {
    switch(name) {
        case 'Glutine':
            return <GlutenIcon />;
        case 'Uova':
            return <EggIcon />;
        case 'Arachidi': 
            return <PeanutsIcon />;
        case 'Lattosio': 
            return <MilkIcon />;
        case 'Crostacei':
            return <CrustaceanIcon />;
        case 'Pesce': 
            return <FishIcon />;
        case 'Soia': 
            return <SoyIcon />;
        case 'Frutta a guscio': 
            return <NutsIcon />;
        case 'Sedano': 
            return <CeleryIcon />;
        case 'Senape': 
            return <MustardIcon />;
        case 'Semi di sesamo': 
            return <SesameIcon />;
        case 'Anidride solforosa':
            return <SulfitesIcon />;
        case 'Lupini':  
            return <LupinsIcon />;
        case 'Molluschi':
            return <ShellfishIcon />;
        default:
            return null;
    }
};
export {CeleryIcon, CrustaceanIcon, EggIcon, FishIcon, GlutenIcon, LupinsIcon, MilkIcon, MustardIcon, NutsIcon, PeanutsIcon, SesameIcon, ShellfishIcon, SoyIcon, SulfitesIcon};